/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menulunchempty2Inputs */

const en_menulunchempty2 = /** @type {(inputs: Menulunchempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No lunch menu yet. Photograph today's specials or the weekly board – one photo is enough – or enter the dishes yourself.`)
};

const de_menulunchempty2 = /** @type {(inputs: Menulunchempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein Mittagsmenü. Fotografier das Tagesangebot oder die Wochentafel – ein Foto reicht – oder trag die Gerichte selbst ein.`)
};

/**
* | output |
* | --- |
* | "No lunch menu yet. Photograph today's specials or the weekly board – one photo is enough – or enter the dishes yourself." |
*
* @param {Menulunchempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menulunchempty2 = /** @type {((inputs?: Menulunchempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menulunchempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menulunchempty2(inputs)
	return de_menulunchempty2(inputs)
});
export { menulunchempty2 as "menuLunchEmpty" }